// src/components/assets/Notification.tsx
import React from 'react';
import { X } from 'lucide-react';

interface NotificationProps {
  status: {
    show: boolean;
    message: string;
    type: 'success' | 'error';
  };
  onClose: () => void;
}

const Notification: React.FC<NotificationProps> = ({ status, onClose }) => {
  if (!status.show) return null;

  const isSuccess = status.type === 'success';
  const baseClasses = 'fixed top-4 right-4 z-50 p-4 rounded-lg shadow-lg max-w-[90%] sm:max-w-md';
  const typeClasses = isSuccess
    ? 'bg-green-100 border border-green-400 text-green-700'
    : 'bg-red-100 border border-red-400 text-red-700';

  const SuccessIcon = () => (
    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
    </svg>
  );

  const ErrorIcon = () => (
    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
    </svg>
  );

  return (
    <div className={`${baseClasses} ${typeClasses}`}>
      <div className="flex items-center">
        {isSuccess ? <SuccessIcon /> : <ErrorIcon />}
        <span className="text-sm">{status.message}</span>
        <button onClick={onClose} className="ml-4 text-gray-500 hover:text-gray-700">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default Notification;